import React, { useState } from "react"
import PropTypes from 'prop-types'
import Button from 'react-bootstrap/Button'
import axios from "axios"
import 'reactjs-popup/dist/index.css'

import { Translate } from "../Translator"
import { IsEmptyString } from "../GeneralFunctions"
import { OAuthApiStartPolling, OAuthApiStopPolling } from "../../ExternalApi/OAuthApi"
import { PhoneApiSubscribe } from "../../ExternalApi/PhoneApi"

const TelephonySettingsKwebbl = (props) => {

    const [mRepainter, SetRepainter] = useState(0) 

    const mSettingsFixed = false //props.PhoneSettings["$Fixed"] === "y"
    const [mApiKey, SetApiKey] = useState(props.PhoneSettings["ApiKey"] ?? "") 
    const [mApiSecret, SetApiSecret] = useState(props.PhoneSettings["ApiSecret"] ?? "") 

    const [mWaitingForState, SetWaitingForState] = useState("")
    const [mOAuthWindow, SetOAuthWindow] = useState(null) 

    const [mError, SetError] = useState("") 

    const OAuthPollResult = async (aResult, aValue, aOAuthWindow) =>
    {
        console.log("OAuthPollResult",aResult,aValue,aOAuthWindow)
        try 
        { 
            if (aOAuthWindow !== null)
            {
                aOAuthWindow.close() 
                aOAuthWindow = null
                SetOAuthWindow(null)
            }
        } 
        catch {}

        if (aResult)
        {
            console.log("OAuthPollResult success: " + JSON.stringify(aValue))
            if (aValue.Code)
            {
                await GetKwebblTokensFromAuthorizationCode(aValue.Code)
            }
            else
            {
                SetError("Failed to authenticate. No authorizationcode found")  
            }
        }
        else
        {
            console.log("OAuthPollResult error",aValue)  
            SetError("Failed to authenticate")          
        }

        SetWaitingForState("")
    }

    const RandomState = () => 
    {
        let Result = "client2020WEB"

        var characters = '0123456789ABCDEFGHIJKLMNOPQRSTUVWXYZ'
        for ( var i = 0; i < 27; i++ ) 
        {
            Result += characters.charAt(Math.floor(Math.random() * characters.length))
        }
        
        return Result
    }
    
    const UpdateSettings = async (aApiKey, aApiSecret, aAccessToken, aRefreshToken, aTokenExpirationTime, aUserAgent) => {
        const SecurityToken = localStorage.getItem("securitytoken")

        const result = await axios.post("https://api.cloudcti.nl/apibeta/v2/kwebbl/usersettings",
            {
                ApiKey: aApiKey,
                ApiSecret: aApiSecret,
                AccessToken: aAccessToken,
                RefreshToken: aRefreshToken,
                TokenExpirationTime: aTokenExpirationTime,
                UserAgent: aUserAgent
            },
            {
                headers: {
                    Accept: "application/json",
                    Authorization: "Bearer " + SecurityToken
                }
            })
        if (result.status === 204)
        {
            props.OnPhoneSubscribe()
        }
        else
        {
            console.log("GetKwebblTokensFromAuthorizationCode error", "Result has no data") 
        }
    } 
    
    const GetKwebblOauthUrl = (aState) => {
        return "https://realtime.api.kwebbl.net/authorize" +    
            "?client_id=" + mApiKey +
            "&redirect_uri=https%3A%2F%2Fauth.cloudcti.nl%2Fwebapi%2Foauth2" +
            "&state=" + aState +
            "&response_type=code" +
            "&scope=company.users%20calls.events.personal%20calls.events%20calls.create.personal%20calls.create"
    }

    const GetKwebblTokensFromAuthorizationCode = async (aCode) => {
        try
        {
            const result = await axios.get("https://api.cloudcti.nl/apibeta/v2/kwebbl/token?apikey=" + mApiKey + "&apisecret=" + mApiSecret + "&code=" + aCode,
                {
                    headers: {
                        Accept: "application/json",
                        Authorization: "Basic " + btoa(`KwebblOAuth:AndreArashArjenBramCarinJanKeesJeroen`)
                    }
                })
            if (result.data)
            {
                console.log("GetKwebblTokensFromAuthorizationCode result", result.data)
                UpdateSettings(mApiKey, mApiSecret, result.data.access_token, result.data.refresh_token, (Date.now() + (result.data.expires_in * 1000)).toString(), "Legacy")
            }
            else
            {
                console.log("GetKwebblTokensFromAuthorizationCode error", "Result has no data") 
            }
        }
        catch (ex)
        {
            console.log("GetKwebblTokensFromAuthorizationCode error", ex)
        }       
    }

    const StartOAuth = () =>
    {
        const State = RandomState()        
        const OAuthWindow = window.open(GetKwebblOauthUrl(State), "_blank", 'popup=yes,titlebar=0,left=' + ((screen.availWidth - 750)/2)  + ',top=' + ((screen.availHeight - 750)/2)  + ',width=750,height=750')
        
        SetOAuthWindow(OAuthWindow)
        OAuthApiStartPolling(State, OAuthPollResult, OAuthWindow)
        SetWaitingForState(State)
    }

    const StopWaiting = () => {
        OAuthApiStopPolling(State, OAuthPollResult)
        SetWaitingForState("")
    }

    const HtmlButtonSection = () => {
        return /* ApiKey or ApiSecret has changed -> Update settings*/ (mApiKey !== props.PhoneSettings["ApiKey"] || mApiSecret !== props.PhoneSettings["ApiSecret"]) ? <Button variant="primary" onClick={() => UpdateSettings(mApiKey, mApiSecret, "", "", "", "")}> <span style={{ paddingLeft: "6px"}}>{Translate("Update settings")}</span></Button> :
            /* ApiKey or ApiSecret is empty -> Cannot start oauth */ (IsEmptyString(mApiKey) || IsEmptyString(mApiSecret)) ? <><Button variant="primary" disabled>{Translate("Start OAuth verification")}</Button> Enter your API data</> :
            /* Currently waiting on OAuth -> Give option to stop waiting */ !IsEmptyString(mWaitingForState) ? <><Button variant="primary" onClick={() => StopWaiting()}>{Translate("Stop waiting")}</Button> Waiting for OAuth verification</> :
            /* Currently does not have an accesstoken and refreshtoken -> Button to start OAuth */ (IsEmptyString(props.PhoneSettings["AccessToken"]) || IsEmptyString(props.PhoneSettings["RefreshToken"])) ? <><Button variant="primary" onClick={() => StartOAuth()}>{Translate("Start OAuth verification")}</Button> <span style={{ paddingLeft: "6px"}}>Not authorized</span></> :
            /* ELSE (Currently does have an accesstoken and refreshtoken) -> Button to reset OAuth */<><Button variant="primary" onClick={() => StartOAuth()}>{Translate("Reset OAuth verification")}</Button> <span style={{ paddingLeft: "6px"}}>Authorization OK</span></>
    }

    if (mSettingsFixed)
    {
        return (
            <span>
                <div className="smalltext">{Translate("API key")}: {mApiKey}</div>
                <div className="smalltext">{Translate("API secret")}: {mApiSecret}</div>
                {HtmlButtonSection()}
            </span>
        )
    }
    else
    {
        return (
            <span>
                <table width="100%" cellPadding={4} className="smalltext">
                <tbody>
                <tr>
                    <td>{Translate("API key")}</td>
                    <td><input autoComplete="kwebbl.apikey" value={mApiKey} type="text" onChange={(event) => { SetApiKey(event.target.value) }} style={{ width: "300px"}}/></td>
                </tr>
                <tr>
                    <td>{Translate("API secret")}</td>
                    <td><input autoComplete="kwebbl.apisecret" value={mApiSecret} type="text" onChange={(event) => { SetApiSecret(event.target.value) }} style={{ width: "300px"}}/></td>
                </tr>
                </tbody>
                </table>
                <br/>
                {HtmlButtonSection()}
            </span>
        )
    }
}

TelephonySettingsKwebbl.propTypes = {
    PhoneSettings: PropTypes.object,
    OnUpdatePhoneSettings: PropTypes.func,
    OnPhoneSubscribe: PropTypes.func
}

export default TelephonySettingsKwebbl